import React, { useState, useEffect } from "react";

import Benefit from "./Benefit";
import Card from "./Card";
import IndexPicture from "./IndexPicture";
import FeaturedProducts from "./FeaturedProducts";

import Insta from "./Insta";
import IndexMiddle from "./IndexMiddle";
import IndexTwo from "./IndexTwo";
import IndexTwo2 from "./IndexTwo2";
import IndexTwo3 from "./IndexTwo3";
import Bottom from "./Bottom";
import ReactGA from "react-ga";
import ScriptTag from "react-script-tag";
import { functions, httpsCallable } from "../../firebase";
import ReactPageScroller from "react-page-scroller";

const Index = ({ currentLocation }) => {
  const [currentPgae, setCurrentPage] = useState(null);
  console.log("home re-rending");
  const [numOfPic, setNumOfPic] = useState(4.5);
  const handlePageChange = (number) => {
    setCurrentPage(number);
  };

  const sendSignupEmail = httpsCallable(functions, "sendSignupEmail");
  const mailgunSendEmail = httpsCallable(functions, "mailgunSendEmail");
  const easyPostcreateShipment = httpsCallable(
    functions,
    "easyPostcreateShipment"
  );
  useEffect(() => {
    // Google Analytics Set Up
    // const gaTrackingId = "UA-221050560-1"; // enter your Tracking ID
    // ReactGA.initialize(gaTrackingId, {
    //   debug: true,
    //   titleCase: false,
    // });
    // ReactGA.event({
    //   category: "User",
    //   action: "Visited index",
    // });

    sendSignupEmail({ dest: "rnwldms@gmail.com" }).then((res) =>
      console.log(res)
    );
    mailgunSendEmail().then((res) => console.log(res));

    easyPostcreateShipment()
      .then((result) => {
        console.log(result);
        console.log(result.data.id);
        console.log(result.data.postage_label.id);
        console.log(result.data.postage_label.label_url);
      })
      .catch((error) => console.log(error));

    function handleResize() {
      if (+window.innerWidth < 800) {
        setNumOfPic(2.5);
      } else if (+window.innerWidth < 400) {
        setNumOfPic(1.5);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize");
    };
  }, []);

  return (
    <>
      <ScriptTag
        isHydrating={true}
        type="text/javascript"
        src="https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js"
      />
      <ScriptTag
        isHydrating={true}
        type="text/javascript"
        src="http://code.jquery.com/jquery-1.11.3.min.js"
      />

      {/* <ReactPageScroller
        pageOnChange={handlePageChange}
        containerHeight={window.innerHeight * 1.5}
        customPageNumber={currentPgae}
      > */}
      <IndexPicture />
      <FeaturedProducts currentLocation={currentLocation} numOfPic={numOfPic} />
      <IndexMiddle />
      <IndexTwo />
      <IndexTwo2 />
      <IndexTwo3 />
      {/* </ReactPageScroller> */}
      {/* <button onClick={click}>Click</button> */}

      {/* <Exp /> */}
      {/* <CleanBanner /> */}
      {/* <Benefit /> */}

      {/* <Testimonials /> */}
      {/* <Card /> */}
      {/* <Nature /> */}
      {/* <Insta /> */}
      {/* <Testimonial1 /> */}
      <Bottom />
    </>
  );
};

export default Index;
